import { isVNode as o, Comment as i, Fragment as l } from "vue";
function n(r) {
  return r.some((e) => o(e) ? !(e.type === i || e.type === l && !n(e.children)) : !0) ? r : null;
}
function p(r, e) {
  return r && n(r()) || e();
}
function c(r, e, t) {
  return r && n(r(e)) || t(e);
}
function m(r, e) {
  const t = r && n(r());
  return e(t || null);
}
function s(r, e, t) {
  const u = r && n(r(e));
  return t(u || null);
}
function a(r) {
  return !(r && n(r()));
}
export {
  a as isSlotEmpty,
  p as resolveSlot,
  c as resolveSlotWithProps,
  m as resolveWrappedSlot,
  s as resolveWrappedSlotWithProps
};
